module.exports = __webpack_public_path__ + "img/softwcopr1.74444dad.png";